import React from "react";
import { motion, cubicBezier } from "framer-motion";

//Data
import { menuData } from "../data/menuData";

//Default transitioncategories
const easing = cubicBezier(0.6, 0.01, -0.05, 0.9);
const transition = { duration: 0.8, ease: easing };

const menu = (props) => {
  const { setActiveObject, workingHours, getClass } = props;
  const offer = menuData.filter(item => item.category === "offer");  
  const breakfast = menuData.filter(item => item.category === "breakfast");  
  const chicken = menuData.filter(item => item.category === "chicken");  
  const pork = menuData.filter(item => item.category === "pork");  
  const burger = menuData.filter(item => item.category === "burger");  
  const beef = menuData.filter(item => item.category === "beef");  
  const barbecue = menuData.filter(item => item.category === "barbecue");  
  const sausage = menuData.filter(item => item.category === "sausage");  
  const vegan  = menuData.filter(item => item.category === "vegan");  
  const salad = menuData.filter(item => item.category === "salad");  
  const sides = menuData.filter(item => item.category === "sides");  
  const desert = menuData.filter(item => item.category === "desert");  
  const drinks = menuData.filter(item => item.category === "drinks");  
  const pizza = menuData.filter(item => item.category === "pizza");  


  const isBeforeNoon = new Date().getHours() < 12;
  //const pizzaTime = new Date().getHours() * 60 + new Date().getMinutes() >= 12 * 60 && new Date().getHours() * 60 + new Date().getMinutes() <= 22 * 60 + 30;
  const pizzaTime = new Date().getHours() >= 16;

  
  return (
    <>
      <motion.h4
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 2.4, ...transition }}
        className="menu-title"
      >
        <span>Акција</span>
      </motion.h4>
      <ul className="list-menu offer">
        {offer.map((product) => (
          <motion.li
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 2.4, ...transition }}
            key={product.id}
            onClick={() => {
              setActiveObject(product);
              workingHours();
            }}
            className={getClass(product.id)} 
          >
            <img  className="list-img" src={product.image} alt="Ресторан идзуо" />
            <span className="list-menu-info">
              <span className="list-menu-top">
                <span className="list-title">{product.name}</span>
                <span className="list-desc">{product.desc}</span>
              </span>
              <span className="list-price">{product.price} рсд</span>
            </span>
          </motion.li>
        ))}
      </ul>

      {isBeforeNoon && (
        <>
          <motion.h4
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 2.4, ...transition }}
            className="menu-title"
          >
            <span>Доручак</span>
          </motion.h4>
          <ul className="list-menu">
            {breakfast.map((product) => (
              <motion.li
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 2.4, ...transition }}
                key={product.id}
                onClick={() => {
                  setActiveObject(product);
                  workingHours();
                }}
                className={getClass(product.id)}
              >
                <img  className="list-img" src={product.image} alt="Ресторан идзуо" />
                <span className="list-menu-info">
                  <span className="list-menu-top">
                    <span className="list-title">{product.name}</span>
                    <span className="list-desc">{product.desc}</span>
                  </span>
                  <span className="list-price">{product.price} рсд</span>
                </span>
              </motion.li>
            ))}
          </ul>
        </>
      )}

      {pizzaTime && (
        <>
          <motion.h4
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 2.4, ...transition }}
            className="menu-title"
          >
            <span>Пица 30цм</span>
          </motion.h4>
          <ul className="list-menu">
            {pizza.map((product) => (
              <motion.li
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 2.4, ...transition }}
                key={product.id}
                onClick={() => {
                  setActiveObject(product);
                  workingHours();
                }}
                className={getClass(product.id)}
              >
                <img  className="list-img" src={product.image} alt="Ресторан идзуо" />
                <span className="list-menu-info">
                  <span className="list-menu-top">
                    <span className="list-title">{product.name}</span>
                    <span className="list-desc">{product.desc}</span>
                  </span>
                  <span className="list-price">{product.price} рсд</span>
                </span>
              </motion.li>
            ))}
          </ul>
        </>
      )}

      <motion.h4
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 2.4, ...transition }}
        className="menu-title"
      >
        <span>Пилетина</span>
      </motion.h4>
      <ul className="list-menu">
        {chicken.map((product) => (
          <motion.li
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 2.4, ...transition }}
            key={product.id}
            onClick={() => {
              setActiveObject(product);
              workingHours();
            }}
            className={getClass(product.id)}
          >
            <img  className="list-img" src={product.image} alt="Ресторан идзуо" />
            <span className="list-menu-info">
              <span className="list-menu-top">
                <span className="list-title">{product.name}</span>
                <span className="list-desc">{product.desc}</span>
              </span>
              <span className="list-price">{product.price} рсд</span>
            </span>
          </motion.li>
        ))}
      </ul>

      <motion.h4
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 2.4, ...transition }}
        className="menu-title"
      >
        <span>Свињетина</span>
      </motion.h4>
      <ul className="list-menu">
        {pork.map((product) => (
          <motion.li
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 2.4, ...transition }}
            key={product.id}
            onClick={() => {
              setActiveObject(product);
              workingHours();
            }}
            className={getClass(product.id)}
          >
            <img  className="list-img" src={product.image} alt="Ресторан идзуо" />
            <span className="list-menu-info">
              <span className="list-menu-top">
                <span className="list-title">{product.name}</span>
                <span className="list-desc">{product.desc}</span>
              </span>
              <span className="list-price">{product.price} рсд</span>
            </span>
          </motion.li>
        ))}
      </ul>


      <motion.h4
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 2.4, ...transition }}
        className="menu-title"
      >
        <span>Бургери</span>
      </motion.h4>
      <ul className="list-menu">
        {burger.map((product) => (
          <motion.li
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 2.4, ...transition }}
            key={product.id}
            onClick={() => {
              setActiveObject(product);
              workingHours();
            }}
            className={getClass(product.id)}
          >
            <img  className="list-img" src={product.image} alt="Ресторан идзуо" />
            <span className="list-menu-info">
              <span className="list-menu-top">
                <span className="list-title">{product.name}</span>
                <span className="list-desc">{product.desc}</span>
              </span>
              <span className="list-price">{product.price} рсд</span>
            </span>
          </motion.li>
        ))}
      </ul>


      <motion.h4
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 2.4, ...transition }}
        className="menu-title"
      >
        <span>Јунетина</span>
      </motion.h4>
      <ul className="list-menu">
        {beef.map((product) => (
          <motion.li
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 2.4, ...transition }}
            key={product.id}
            onClick={() => {
              setActiveObject(product);
              workingHours();
            }}
            className={getClass(product.id)}
          >
            <img  className="list-img" src={product.image} alt="Ресторан идзуо" />
            <span className="list-menu-info">
              <span className="list-menu-top">
                <span className="list-title">{product.name}</span>
                <span className="list-desc">{product.desc}</span>
              </span>
              <span className="list-price">{product.price} рсд</span>
            </span>
          </motion.li>
        ))}
      </ul>

      <motion.h4
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 2.4, ...transition }}
        className="menu-title"
      >
        <span>Јела на роштиљу</span>
      </motion.h4>
      <ul className="list-menu">
        {barbecue.map((product) => (
          <motion.li
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 2.4, ...transition }}
            key={product.id}
            onClick={() => {
              setActiveObject(product);
              workingHours();
            }}
            className={getClass(product.id) + ' barbecue'}
          >
            <img  className="list-img" src={product.image} alt="Ресторан идзуо" />
            <span className="list-menu-info">
              <span className="list-menu-top">
                <span className="list-title">{product.name}</span>
                <span className="list-desc">{product.desc}</span>
              </span>
              <span className="list-price">{product.price} рсд</span>
            </span>
          </motion.li>
        ))}
      </ul>

      <motion.h4
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 2.4, ...transition }}
        className="menu-title"
      >
        <span>Кобасице</span>
      </motion.h4>
      <ul className="list-menu">
        {sausage.map((product) => (
          <motion.li
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 2.4, ...transition }}
            key={product.id}
            onClick={() => {
              setActiveObject(product);
              workingHours();
            }}
            className={getClass(product.id)}
          >
            <img  className="list-img" src={product.image} alt="Ресторан идзуо" />
            <span className="list-menu-info">
              <span className="list-menu-top">
                <span className="list-title">{product.name}</span>
                <span className="list-desc">{product.desc}</span>
              </span>
              <span className="list-price">{product.price} рсд</span>
            </span>
          </motion.li>
        ))}
      </ul>

      <motion.h4
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 2.4, ...transition }}
        className="menu-title"
      >
        <span>Посна јела</span>
      </motion.h4>
      <ul className="list-menu">
        {vegan.map((product) => (
          <motion.li
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 2.4, ...transition }}
            key={product.id}
            onClick={() => {
              setActiveObject(product);
              workingHours();
            }}
            className={getClass(product.id)}
          >
            <img  className="list-img" src={product.image} alt="Ресторан идзуо" />
            <span className="list-menu-info">
              <span className="list-menu-top">
                <span className="list-title">{product.name}</span>
                <span className="list-desc">{product.desc}</span>
              </span>
              <span className="list-price">{product.price} рсд</span>
            </span>
          </motion.li>
        ))}
      </ul>


      <motion.h4
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 2.4, ...transition }}
        className="menu-title"
      >
        <span>Салате</span>
      </motion.h4>
      <ul className="list-menu">
        {salad.map((product) => (
          <motion.li
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 2.4, ...transition }}
            key={product.id}
            onClick={() => {
              setActiveObject(product);
              workingHours();
            }}
            className={getClass(product.id)}
          >
            <img  className="list-img" src={product.image} alt="Ресторан идзуо" />
            <span className="list-menu-info">
              <span className="list-menu-top">
                <span className="list-title">{product.name}</span>
                <span className="list-desc">{product.desc}</span>
              </span>
              <span className="list-price">{product.price} рсд</span>
            </span>
          </motion.li>
        ))}
      </ul>

      <motion.h4
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 2.4, ...transition }}
        className="menu-title"
      >
        <span>Прилози</span>
      </motion.h4>
      <ul className="list-menu">
        {sides.map((product) => (
          <motion.li
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 2.4, ...transition }}
            key={product.id}
            onClick={() => {
              setActiveObject(product);
              workingHours();
            }}
            className={getClass(product.id)}
          >
            <img  className="list-img" src={product.image} alt="Ресторан идзуо" />
            <span className="list-menu-info">
              <span className="list-menu-top">
                <span className="list-title">{product.name}</span>
                <span className="list-desc">{product.desc}</span>
              </span>
              <span className="list-price">{product.price} рсд</span>
            </span>
          </motion.li>
        ))}
      </ul>

      <motion.h4
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 2.4, ...transition }}
        className="menu-title"
      >
        <span>Десерт</span>
      </motion.h4>
      <ul className="list-menu">
        {desert.map((product) => (
          <motion.li
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 2.4, ...transition }}
            key={product.id}
            onClick={() => {
              setActiveObject(product);
              workingHours();
            }}
            className={getClass(product.id)}
          >
            <img  className="list-img" src={product.image} alt="Ресторан идзуо" />
            <span className="list-menu-info">
              <span className="list-menu-top">
                <span className="list-title">{product.name}</span>
                <span className="list-desc">{product.desc}</span>
              </span>
              <span className="list-price">{product.price} рсд</span>
            </span>
          </motion.li>
        ))}
      </ul>

      <motion.h4
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 2.4, ...transition }}
        className="menu-title"
      >
        <span>Пиће</span>
      </motion.h4>
      <ul className="list-menu">
        {drinks.map((product) => (
          <motion.li
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 2.4, ...transition }}
            key={product.id}
            onClick={() => {
              setActiveObject(product);
              workingHours();
            }}
            className={getClass(product.id)}
          >
            <img  className="list-img" src={product.image} alt="Ресторан идзуо" />
            <span className="list-menu-info">
              <span className="list-menu-top">
                <span className="list-title">{product.name}</span>
                <span className="list-desc">{product.desc}</span>
              </span>
              <span className="list-price">{product.price} рсд</span>
            </span>
          </motion.li>
        ))}
      </ul>
    </>
  );

};

export default menu;
